import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "진행하시겠습니까?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "(회원가입 시 입력한 주소로 3~4일이내", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "기사님이 방문합니다)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "수거 신청 접수가 완료 됐습니다. 회원가입 시 입력한 주소로"),
  /*#__PURE__*/_createElementVNode("div", null, "3~4일 내 한진택배 기사님이 방문할 예정입니다.")
], -1)

import { ref, reactive, inject } from 'vue';
  import { IProgram } from '@/types/program';
  import _ from 'lodash';
  import { request } from '@/utils';
  import { ColorVariants } from '@/constants';

  interface IProps {
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    program: IProgram;
  }

  
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const dialog = reactive({
    apply: false,
    applySuccess: false,
    operationSuccess: false,
    requestWaitingLists: false,
    error: false,
  });

  const requestWaitingListsMessage = ref('');
  const errMessage = ref('');

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
  }

  const start = () => {
    showDialog('apply');
  };

  async function subscribeWaitingList() {
    await request.post('request_waiting_lists', {
      kind: 'collection',
      program_id: props.program.id
    });
    showDialog('operationSuccess');
  }

  async function apply() {
    try {
      await request.post('user_requests', {
        target_id: props.program.id,
        target_type: 'Program',
        type: 'CollectionRequest',
        people_collection: props.program.people_collection,
        group_name: props.program.group_name
      }, {
        loading: { silent: true }
      });
      await refreshPageData();
      showDialog('applySuccess');
    } catch (e) {
      closeDialog();
      const errorMsg = _.get(e, 'message');
      const code = _.get(e, 'code');
      // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
      if (String(code) === '40008') {
        requestWaitingListsMessage.value = errorMsg;
        showDialog('requestWaitingLists');
        return;
      }
      // request.ts已经处理过这个code了
      if (String(code) !== '40305') {
        errMessage.value = errorMsg;
        showDialog('error');
      }
      throw e;
    }
  }

  expose({
    start
  });

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).apply,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).apply) = $event)),
      title: "감사해요, 원더플 피플!",
      class: "dialog-coca-cola",
      btns: [
        { text: '아니오', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '신청할게요', style: _unref(ColorVariants).primary, click: () => apply() }
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(__props.program.collection_count + 1) + "차 제로 웨이스트 박스 수거를", 1),
          _hoisted_2,
          _hoisted_3,
          _hoisted_4
        ])
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).applySuccess,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).applySuccess) = $event)),
      title: "원더플 피플!",
      class: "dialog-coca-cola",
      btns: [
        { text: '확인', style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).operationSuccess,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).operationSuccess) = $event)),
      title: "원더플 피플!",
      class: "dialog-coca-cola",
      content: "정보가 성공적으로 입력 되었습니다.",
      btns: [
        { text: '확인', style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ]
    }, null, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).requestWaitingLists,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).requestWaitingLists) = $event)),
      title: "원더플 피플!",
      class: "dialog-coca-cola",
      content: requestWaitingListsMessage.value,
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '신청할게요', style: _unref(ColorVariants).primary, click: () => subscribeWaitingList() }
      ]
    }, null, 8, ["visible", "content", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).error,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dialog).error) = $event)),
      title: "원더플 피플!",
      class: "dialog-coca-cola",
      content: errMessage.value,
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
      ]
    }, null, 8, ["visible", "content", "btns"])
  ]))
}
}

})